// extracted by mini-css-extract-plugin
module.exports = {"onboarding":"PageTop_onboarding__3eEQ2"};